import React from 'react'
import TransactionComponent from '../Components/PartnerTransaction/TransactionComponent'

function TransactionPage() {
    return (
        <TransactionComponent/>
    )
}

export default TransactionPage